import { render } from "./FlexMessage.vue?vue&type=template&id=3369079c"
import script from "./FlexMessage.vue?vue&type=script&lang=ts"
export * from "./FlexMessage.vue?vue&type=script&lang=ts"

import "./FlexMessage.vue?vue&type=style&index=0&id=3369079c&lang=scss"
script.render = render

export default script